export const ELocalStorageKey = {
  LANGUAGE: 'language',
  THEME: 'ui_theme',
};
